import { useCallback, useState } from "react";

import { useNavigate } from "react-router";

import { FORM_ERROR_DELAY_IN_MS, StateCode } from "@covertree/consts";
import { useFormWithNotification } from "@covertree/hooks";
import {
  getAgentHouseDetailsFormSchema,
  HomeDetailsForm,
} from "@covertree/new-business-forms";
import { PolicyUsage } from "@covertree/new-business-graphql";
import {
  selectHomeDetailsFormDefaultValues,
  selectPolicyUsage,
  selectNewHomeState,
  setUnitsConstruction,
  setUnitsDetails,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";

import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch } from "@redux/hooks";
import { navigateToPolicyStep, NewPolicyRoutes } from "@routing/paths";

import { HomeDetailsView } from "./HomeDetailsView";

export function HomeDetailsStep() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isTenantFlow =
    useNewBusinessSelector(selectPolicyUsage) === PolicyUsage.Tenant;

  const state = useNewBusinessSelector(selectNewHomeState) as StateCode;

  const defaultValues = useNewBusinessSelector(
    selectHomeDetailsFormDefaultValues
  );

  const [isLoading, setIsLoading] = useState(false);

  const form = useFormWithNotification<HomeDetailsForm>({
    mode: "all",
    shouldUnregister: false,
    defaultValues,
    delayError: FORM_ERROR_DELAY_IN_MS,
    reValidateMode: "onSubmit",
    resolver: yupResolver(getAgentHouseDetailsFormSchema(isTenantFlow, state)),
  });

  // TODO: useScrollToErrorSection

  const onSubmit = useCallback(
    ({
      communityName,
      homeFixtures,
      homeType,
      location,
      manufacturer,
      makeCustom,
      modelHome,
      modelYear,
      roofShape,
      roofYearYyyy,
      homeHudNumber,
      skirtingType,
      totalSquareFootage,
      homeWidth,
      homeLength,
    }: HomeDetailsForm) => {
      setIsLoading(true);
      dispatch(
        setUnitsConstruction({
          unitIndex: 0,
          unitConstruction: {
            homeFixtures,
            homeType,
            manufacturerName: manufacturer?.value,
            makeCustom,
            modelHome,
            modelYear: modelYear?.value,
            roofShape,
            roofYearYyyy,
            totalSquareFootage,
            homeWidth: homeWidth ?? undefined,
            homeLength: homeLength ?? undefined,
            homeHudNumber,
            skirtingType,
          },
        })
      );
      dispatch(
        setUnitsDetails({
          unitIndex: 0,
          unitDetails: {
            communityName: communityName?.value,
            location,
          },
        })
      );
      navigateToPolicyStep(
        navigate,
        NewPolicyRoutes.PERSONAL_DETAILS,
        NewPolicyRoutes.HOME_DETAILS
      );
      setIsLoading(false);
    },
    [dispatch]
  );

  return (
    <HomeDetailsView
      isTenantFlow={isTenantFlow}
      form={form}
      onSubmit={onSubmit}
      loading={isLoading}
    />
  );
}
